import { Badge, Box, Button } from '@material-ui/core';
import React, { ReactElement } from 'react';
import Info from '@material-ui/icons/Info';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Add from '@material-ui/icons/Add';

import { BackButton, DialogWindow, DialogWindowHeader, SmallMapCard } from '..';
import { Project } from '../../../redux';
import { Body1 } from '../../atoms';

import './selected-map-dialog.styles.scss';
import { useTranslation } from 'react-i18next';

export interface ISelectedMapDialogProps {
	existingComparison: boolean;
	open: boolean;
	project: Project;
	selectedProjects: Project[];
	deselectMap: (project: Project) => void;
	onClose: () => void;
	onConfirmSelection: () => void;
	onBackPressed: () => void;
}

export function SelectedMapDialog(
	props: ISelectedMapDialogProps
): ReactElement {
	const {
		existingComparison,
		project,
		selectedProjects,
		open,
		onClose,
		deselectMap,
		onConfirmSelection,
		onBackPressed
	} = props;

	const { t } = useTranslation('comparison');

	return (
		<DialogWindow
			className="selected-map-dialog"
			open={open}
			onClose={onClose}
		>
			<DialogWindowHeader title={t('chosenMaps')} onClose={onClose} />
			{selectedProjects.length === 3 && (
				<Box className="selected-map-warning">
					<Info className="info-icon" />
					<Body1>{t('removeMapsForOthers')}</Body1>
				</Box>
			)}
			<Box className="selected-maps-container">
				<Body1 className="map-count">
					{t('amountChosenMaps', {
						amount: selectedProjects.length + 1
					})}
				</Body1>
				{project && (
					<SmallMapCard
						className="main-map"
						label={
							<Badge className="main-map-badge">
								<Body1>{t('baseMap')}</Body1>
							</Badge>
						}
						mapId={project.metaDataId}
					/>
				)}
				{selectedProjects.map((selectedMap: Project, index: number) => (
					<Box key={index}>
						<SmallMapCard
							className="selected-map"
							mapId={selectedMap.metaDataId}
							iconButtonIcon={
								<DeleteOutline htmlColor="#2965FB" />
							}
							onIconClick={() => deselectMap(selectedMap)}
						/>
					</Box>
				))}
			</Box>
			{existingComparison && (
				<Box className="selected-maps-footer">
					<BackButton
						text={t('returnToComparison')}
						onClick={onBackPressed}
					/>
					<Button
						color="primary"
						variant="contained"
						onClick={onConfirmSelection}
					>
						<Add />
						{t('chooseMaps')}
					</Button>
				</Box>
			)}
		</DialogWindow>
	);
}
